import { render, staticRenderFns } from "./UserCounter.vue?vue&type=template&id=62153b36&scoped=true&lang=pug&"
import script from "./UserCounter.vue?vue&type=script&lang=js&"
export * from "./UserCounter.vue?vue&type=script&lang=js&"
import style0 from "./UserCounter.vue?vue&type=style&index=0&id=62153b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62153b36",
  null
  
)

export default component.exports